import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import * as globals from '../globals';
import { AuthHttp, AuthConfig } from 'angular2-jwt';

@Injectable()
export class customerService {

  private customerurl = globals.APIURL + '/customer';
  private customerpageurl = globals.APIURL + '/customer/page';
  private contacturl = this.customerurl + '/contact';
  private projectcounturl = globals.APIURL + '/projects/customer';

  constructor(private http: Http, public authHttp: AuthHttp) { }

  getCustomersPage(currentPage: number, itemsPerPage: number) {
    console.log('getCustomersPage service called');

    let body = JSON.stringify({currentPage: currentPage, itemsPerPage: itemsPerPage});
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    const options = new RequestOptions({ body: body, headers: headers });
    console.log('Projects: OPTIONS =>', options);
    console.log('URL:', this.customerpageurl);
    return this.authHttp.post(this.customerpageurl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  addCustomer(customerdetails: any): Observable<string> {
    console.log('get users service called');

     let body;
    if (customerdetails.planid == 1) {
      body = JSON.stringify({ customer: { name: customerdetails.name } });
    } else {
      body = JSON.stringify({ customer: {
          name: customerdetails.companyname,
          address: customerdetails.addressone,
          address2: customerdetails.addresstwo,
          city: customerdetails.companycity,
          state: customerdetails.companystate,
          zip: customerdetails.companyzip,
          country: customerdetails.companycountry,
          phone: customerdetails.companyphone,
          fax: customerdetails.companyfax,
          email: customerdetails.primarycontactemail,
          website: customerdetails.companyurl,
          comments: customerdetails.comments,
          rating: customerdetails.rating,
          owner_id: customerdetails.owner_id,
        },
        primarycontact: {
            firstname: customerdetails.primarycontactfirstname,
            lastname: customerdetails.primarycontactlastname,
            phone: customerdetails.primarycontactphone,
            email: customerdetails.primarycontactemail,
            title: customerdetails.title
        }
      });
    }

    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ headers: headers });

    console.log('Projects: OPTIONS =>', options);
    console.log('URL:', this.customerurl);
    return this.authHttp.post(this.customerurl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  updateCustomer(customerdetails: any){
    console.log('get users service called');

    let body = JSON.stringify({
            id: customerdetails.id,
            primary_contact_id: customerdetails.primaryContact_id,
            owner_id: customerdetails.owner_id,
            name: customerdetails.companyname,
            address: customerdetails.addressone,
            address2: customerdetails.addresstwo,
            city: customerdetails.companycity,
            state: customerdetails.companystate,
            zip: customerdetails.companyzip,
            country: customerdetails.companycountry,
            phone: customerdetails.companyphone,
            fax: customerdetails.companyfax,
            email: customerdetails.primarycontactemail,
            website: customerdetails.companyurl,
            enabled: customerdetails.enabled,
            comments: customerdetails.comments,
            rating: customerdetails.rating,
            default_margin: customerdetails.margin
     });


    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ headers: headers });

    console.log('Projects: OPTIONS =>', options);
    console.log('URL:', this.customerurl);
    return this.authHttp.put(this.customerurl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getCustomerInfo(id: number){
    console.log('get customer info service called');
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ body: '', headers: headers });
    console.log('Customers: OPTIONS =>', options);
    console.log('URL:', this.customerurl + '/' + id);
    return this.authHttp.get(this.customerurl + '/' + id, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  addContact(contactdetails){
    console.log('Add new Contact service called');
     let body;
      body = JSON.stringify({
        firstname: contactdetails.firstname,
        lastname: contactdetails.lastname,
        phone: contactdetails.phone,
        email: contactdetails.email,
        title: contactdetails.title,
        customer_id: contactdetails.customer_id
     });

    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ headers: headers });

    console.log('Contacts: OPTIONS =>', options);
    console.log('Add contact URL:', this.contacturl);
    return this.authHttp.post(this.contacturl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

    //Sets customer to Inactive - Deactivates
  changeCustomerStatus(customerID, state): Observable<string> {
    let body = JSON.stringify({ id: customerID, enabled: state });
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    console.log('Login: URL =>', this.customerurl);
    console.log('Login: BODY =>', body);
    console.log('Login: OPTIONS =>', options);

    return this.authHttp.put(this.customerurl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  deleteCustomer(customerid): Observable<string> {
    console.log('delete customer service called');

    let body = JSON.stringify({ id: customerid, enabled: 2 });

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    console.log('Login: URL =>', this.customerurl);
    console.log('Login: BODY =>', body);
    console.log('Login: OPTIONS =>', options);

    return this.authHttp.put(this.customerurl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }


  updateComment(id, comment): Observable<string> {
        console.log('get users service called');

    let body = JSON.stringify({
            id: id,
            comments: comment
     });

    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ headers: headers });

    console.log('Projects: OPTIONS =>', options);
    console.log('URL:', this.customerurl);
    return this.authHttp.put(this.customerurl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getCustomerProjects(id: number): Observable<string> {
    console.log('get customers project service called for id : ', id);
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ body: '', headers: headers });
    console.log('Projects: OPTIONS =>', options);
    console.log('URL:', this.projectcounturl + '/' + id);
    return this.authHttp.get(this.projectcounturl + '/' + id, options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  updateContact(contactdetails) : Observable<string> {
    console.log('Update Contact service called');
    let body = JSON.stringify({
            id: contactdetails.id,
            firstname: contactdetails.firstname,
            lastname: contactdetails.lastname,
            phone: contactdetails.phone,
            email: contactdetails.email,
            title: contactdetails.title,
            customer_id: contactdetails.customer_id
      });


    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ headers: headers });

    console.log('Projects: OPTIONS =>', options);
    console.log('URL:', this.contacturl);
    return this.authHttp.put(this.contacturl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  private extractData(res: Response) {
    let body = res.json();
    console.log('BODY:', body);
    return body || {};
  }

  handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    let errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error('CAUGHT AN ERROR:', errMsg); // log to console instead
    return Observable.throw(errMsg);
  }

}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/customers/customers.service.ts